import { type FC } from "react";
import { SectionTitle } from "@userFrontend/components/SectionTitle";
import { SectionWithTitleAndLabel } from "@userFrontend/components/SectionWithTitleAndLabel";
import { commonInner } from "@userFrontend/features/clientReview/components/ClientReviewInputs/styles.css";
import { MODEL_ATTRIBUTE_NAME } from "@root/shared/utils/constants";
import * as styles from "./styles.css";
import { EmploymentStatusRadio } from "./uiParts/EmploymentStatusRadio";
import { SelectBoxContents } from "./uiParts/SelectBoxContents";
import { type Props } from "./type";

export const Employment: FC<Props> = ({
  questions,
  employmentStatusValue,
  handleEmploymentStatusChange,
  employmentStatusErrorText,
  employmentStatusRef,
  continuedServiceYearsValue,
  handleContinuedServiceYearSelect,
  continuedServiceYearsErrorText,
  continuedServiceYearsRef,
  businessTypeValue,
  handleBusinessTypeSelect,
  businessTypesErrorText,
  businessTypeIdRef,
  occupationValue,
  handleOccupationSelect,
  occupationsErrorText,
  occupationIdRef,
  employmentValue,
  handleEmploymentSelect,
  employmentsErrorText,
  employmentIdRef,
}) => (
  <>
    <SectionTitle text="就業情報" />
    <div>
      <div className={commonInner}>
        <div className={styles.inputOuter}>
          <SectionWithTitleAndLabel title="就業状況" isRequired containerRef={employmentStatusRef}>
            {questions.employmentStatus && (
              <EmploymentStatusRadio
                employmentStatus={questions.employmentStatus}
                handleEmploymentStatusChange={handleEmploymentStatusChange}
                employmentStatusValue={employmentStatusValue}
                employmentStatusErrorText={employmentStatusErrorText}
              />
            )}
          </SectionWithTitleAndLabel>
        </div>
        <div className={styles.inputOuter}>
          <SectionWithTitleAndLabel
            title="この職場での勤続年数"
            isRequired
            containerRef={continuedServiceYearsRef}
          >
            {questions.continuedServiceYearsSelectOptions && (
              <SelectBoxContents
                categoryName="continuedServiceYear"
                value={continuedServiceYearsValue}
                handleSelect={handleContinuedServiceYearSelect}
                selectOptions={questions.continuedServiceYearsSelectOptions}
                errorText={continuedServiceYearsErrorText}
              />
            )}
          </SectionWithTitleAndLabel>
        </div>
        <div className={styles.inputOuter}>
          <SectionWithTitleAndLabel title="職種" isRequired containerRef={businessTypeIdRef}>
            {questions.businessTypesSelectOptions && (
              <SelectBoxContents
                categoryName="businessType"
                value={businessTypeValue}
                handleSelect={handleBusinessTypeSelect}
                selectOptions={questions.businessTypesSelectOptions}
                errorText={businessTypesErrorText}
              />
            )}
          </SectionWithTitleAndLabel>
        </div>
        <div className={styles.inputOuter}>
          <SectionWithTitleAndLabel
            title={MODEL_ATTRIBUTE_NAME.workContent.occupation}
            isRequired
            containerRef={occupationIdRef}
          >
            {questions.occupationsSelectOptions && (
              <SelectBoxContents
                categoryName="occupation"
                value={occupationValue}
                handleSelect={handleOccupationSelect}
                selectOptions={questions.occupationsSelectOptions}
                errorText={occupationsErrorText}
              />
            )}
          </SectionWithTitleAndLabel>
        </div>
        <div className={styles.inputOuter}>
          <SectionWithTitleAndLabel title="雇用形態" isRequired containerRef={employmentIdRef}>
            {questions.employmentsSelectOptions && (
              <SelectBoxContents
                categoryName="employment"
                value={employmentValue}
                handleSelect={handleEmploymentSelect}
                selectOptions={questions.employmentsSelectOptions}
                errorText={employmentsErrorText}
              />
            )}
          </SectionWithTitleAndLabel>
        </div>
      </div>
    </div>
  </>
);
